import { environment } from '@helpers/environment';

// eslint-disable-next-line import/prefer-default-export
export const marketingEmailSignupId = environment.isProduction
  ? 'marketing-email-signup'
  : 'marketing-email-signup-staging';
